import React, { ComponentProps } from "react";
import { TableBody as ReactAriaTableBody } from "react-aria-components";

import EmptyState from "../empty-state";

import styles from "./table-body.module.css";

interface TableBodyProps {
  children: React.ReactNode;
  "data-testid"?: string;
  items?: ComponentProps<typeof ReactAriaTableBody>["items"];
}

function TableBody({ children, "data-testid": testId, items }: TableBodyProps) {
  return (
    <ReactAriaTableBody
      items={items}
      className={styles.body}
      renderEmptyState={() => (
        <EmptyState className={styles.emptyState} heading="No results found" />
      )}
      data-testid={testId}
    >
      {children}
    </ReactAriaTableBody>
  );
}

export default TableBody;
